// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  domain: 'devfailteirelandevents.azureedge.net',
  siteKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
  googleApiKey: 'AIzaSyDyWYReqmmcVyAs5UchNeGFC1g0QaKSb-I',
  lastUpdated: '#{lastUpdated}#',
  contributor : {
    uri: "https://failteirelanddev.azure-api.net/portal/v1/consumer-events/public/event"
  },
  storageAccount : {
    uri : "https://failteirelanddev.azure-api.net/portal/v1/consumer-events/public/event/image"
  },
  cdnEndpoint: "https://cdn.failteireland.ie",
  appInsightsConfig: {
    connectionString: '#{appInsightsConnectionString}#'
  }
};
